var cookieKeys = {
  FX_XSRF: 'fx_xsrf',
  JWT_AUTH_ERROR: 'cx.jwt.auth.error',
  JWT_TOKEN: 'jwt_token_cookie',
  XSRF_TOKEN: 'xsrf_token_cookie'
};
export default cookieKeys;